import router from './router';
import Vue from 'vue';
import { EventBus } from "@/event-bus";

export const functions = {

    /*
     * Não funcionou bem
     */
    unauthorizedActions: function () {

        const jwt = window.localStorage.getItem(this.$appTokenKey);
        if (!jwt) {
            alert("jwt error: ", jwt)
            window.localStorage.setItem(this.$appTokenKey, "");
            return router.push({name: "Login"});
        }

        alert("jwt: ", jwt)

    },

    parseCatch: function (err = null, msg404 = "Erro 404") {

        console.log("parseCatch: ", err);

        if (!err.response) {
            console.warn("Não há resposta: ", err);
            return;
        }

        if (!err.response.status) {
            console.warn("Não há status: ", err);
            return;
        }

        if (404 === parseInt(err.response.status)) {

            if (msg404) {
                EventBus.$emit("toast", {tx: msg404});
            }

            return router.push({name: "Login"});//

    }
    }
}